import React, { FC, useCallback } from 'react'
import { Modal } from 'react-components'
import { stopPropagation } from '../../../utils/dom-utils'
import VideoPlayer from '../video-player'
import { Image } from '../../property-details/expose-gallery/gallery/types'
import { CloseIcon } from '../../property-details/expose-gallery/icons'
import {
    VirtualTourModalContent,
    VirtualTourVideoWrapper,
    VirtualTourCloseButton,
    virtualTourModalStyles,
    OverlayFooterWrapper,
    OverlayCTAButton,
} from './styles'
import { useTranslation } from '../../../hooks/locale'
import { pageTypeEventCategories } from '../../../services/analytics-service/categories'
import { virtualTourVideoEventLabels } from '../../../services/analytics-service/labels'

interface VirtualTourModalProps {
    isOpen: boolean
    onClose: () => void
    video: Image
    handleCtaClick?: (e: React.MouseEvent) => void
}

const VirtualTourModal: FC<VirtualTourModalProps> = ({ isOpen, onClose, video, handleCtaClick }) => {
    const { t } = useTranslation()
    return (
        <div onClick={stopPropagation}>
            <Modal isOpen={isOpen} onRequestClose={onClose} style={virtualTourModalStyles} ariaHideApp={false}>
                <VirtualTourModalContent>
                    <VirtualTourVideoWrapper>
                        <VideoPlayer
                            src={video.src}
                            isActive={isOpen}
                            autoplay
                            analyticsCategory={pageTypeEventCategories.SEARCH_RESULT_LISTING_PAGE}
                            analyticsLabel={virtualTourVideoEventLabels.SrlOverlay}
                        />
                    </VirtualTourVideoWrapper>
                    {!!handleCtaClick && (
                        <OverlayFooterWrapper>
                            <OverlayCTAButton onClick={handleCtaClick}>{t('see_offer')}</OverlayCTAButton>
                        </OverlayFooterWrapper>
                    )}
                </VirtualTourModalContent>
                <VirtualTourCloseButton onClick={onClose}>
                    <CloseIcon />
                </VirtualTourCloseButton>
            </Modal>
        </div>
    )
}

export default VirtualTourModal
